import React from 'react';

import { locale } from '@trqk/utils';
import { Checkbox } from '@trqk/components';

interface ChoosePlanGapAnalysisProps {
    canUseBmatDetections: boolean;
    canUseTrqkDetections: boolean;
    checked: boolean;
    onChange?: OnChange;
}

export const ChoosePlanGapAnalysis = ({
    canUseBmatDetections,
    canUseTrqkDetections,
    checked,
    onChange,
}: ChoosePlanGapAnalysisProps): JSX.Element | null => {
    if (!canUseBmatDetections && !canUseTrqkDetections) {
        return null;
    }

    return (
        <div className="mx-6 pb-6 border-b border-tertiary-200">
            <div className="flex justify-between items-center">
                <p className="text-sm text-tertiary-400 font-semibold mb-2">
                    {
                        locale.enUS.ACCOUNT.SECTIONS.PAYMENT_PLAN.SETTINGS
                            .GAP_ANALYSIS_REPORTS.TITLE
                    }
                </p>
                <div className="relative" style={{ left: 10 }}>
                    <Checkbox
                        size="large"
                        color="primary"
                        checked={checked}
                        inputId="gap-analysis-reports"
                        onChange={onChange}
                    />
                </div>
            </div>
            <ul className="text-sm list-disc ml-6">
                <li>
                    {canUseTrqkDetections && !canUseBmatDetections && (
                        <>
                            {
                                locale.enUS.ACCOUNT.SECTIONS.PAYMENT_PLAN
                                    .SETTINGS.GAP_ANALYSIS_REPORTS
                                    .FROM_TRQK_DATA
                            }
                        </>
                    )}
                    {canUseBmatDetections && (
                        <>
                            {
                                locale.enUS.ACCOUNT.SECTIONS.PAYMENT_PLAN
                                    .SETTINGS.GAP_ANALYSIS_REPORTS
                                    .FROM_EXTERNAL_DATA
                            }
                        </>
                    )}
                </li>
            </ul>
        </div>
    );
};
